import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";
import { combinedExamples, directObjectPronounsExplanation } from "src/data/individual-topics/DirectObjectPronouns";
import { indirectObjectPronounsExamples, indirectObjectPronounsExplanation } from "src/data/individual-topics/IndirectObjectPronouns";
import { Card } from "antd";

const cardText = `
Le di el libro a Marta.                  → I gave the book to Marta.
           ↳ le = to her (indirect), el libro = the book (direct)

Ella me lo agradeció con una sonrisa.   → She thanked me for it with a smile.
           ↳ me = to me (indirect), lo = it (direct)

Mis amigos me dieron flores.            → My friends gave me flowers.
           ↳ me = to me (indirect), flores = flowers (direct)

Yo se las entregué a Marta.             → I gave them to Marta.
           ↳ se = to her (indirect, replaces "le"), las = them (direct)

Te conté la historia ayer.              → I told you the story yesterday.
           ↳ te = to you (indirect), la historia = the story (direct)
`;


const PronombresContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>
            {/* 📌 Direct Object Pronouns Explanation */}
            <div className="section">
                <ExplanationCard cardData={directObjectPronounsExplanation} />
            </div>

            <ExampleTitle />
            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {indirectObjectPronounsExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ExplanationCard cardData={indirectObjectPronounsExplanation} />
            </div>

            <ExampleTitle />
            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {combinedExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>
        </div>
    );
};

const PronombresScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Pronouns (Direct/Indirect Objects)"
            Page={<PronombresContent />}
        />
    );
};

export default PronombresScreen;
